<template>
  <v-treeview
    :active.sync="selectedLocoRegional"
    :items="locoRegionalTree"
    :multiple-active="true"
    activatable
    :value="locoRegionalValues"
    active-class="back--text"
    open-on-click
  >
    <template v-slot:label="{ item, active }">
      <v-icon
        style="font-size: 20px"
        v-show="!item.children"
        v-text="active ? 'fas fa-check-square' : 'far fa-square'"
        :class="active ? 'secondary--text' : ''"
      ></v-icon>
      <span v-show="!item.children">{{ item.name }}</span>
      <span v-if="item.children">{{ item.name }}</span>
    </template>
  </v-treeview>
</template>

<script>
import { Anesthesiology } from '../../../models/Anesthesiology'
export default {
  props: {
    locoRegionalValues: { type: [Array], default: () => [] }
  },
  data() {
    return {
      selectedLocoRegional: this.locoRegionalValues
    }
  },
  computed: {
    locoRegionalTree() {
      return (
        Anesthesiology.query()
          .with('locoRegionalTree.*')
          .first() || {}
      ).locoRegionalTree
    }
  },
  methods: {
    setLocoregional(sites) {
      this.$emit('update:loco-regional-values', sites)
    }
  },
  watch: {
    selectedLocoRegional(val) {
      if (val) {
        this.setLocoregional(val)
      }
    }
  }
}
</script>

<style></style>
